module.exports = __webpack_public_path__ + "img/image8.e5c4c2d6.png";